<template>
    <div class="DelCache">
<!--        <el-popconfirm-->
<!--          confirm-button-text='好的'-->
<!--          cancel-button-text='不用了'-->
<!--          icon="el-icon-info"-->
<!--          icon-color="red"-->
<!--          title="这是一段内容确定删除吗？"-->
<!--        >-->
<!--          <el-button slot="reference">删除</el-button>-->
<!--        </el-popconfirm>-->

        <el-popover
          placement="top"
          width="160"
          v-model="visibleA">
          <p>该操作将清除当前A线在浏览器中的所有缓存，确定清除吗？</p>
          <div class="popoverBut">
            <el-button size="mini" type="text" @click="visibleA = false">取消</el-button>
            <el-button type="primary" size="mini" @click="ClearStorageA">确定</el-button>
          </div>
          <el-button slot="reference" class="popoverButSub">清除浏览器缓存（A线）</el-button>
        </el-popover>

        <el-popover
          placement="top"
          width="160"
          v-model="visibleB">
          <p>该操作将清除当前A线在浏览器中的所有缓存，确定清除吗？</p>
          <div class="popoverBut">
            <el-button size="mini" type="text" @click="visibleB = false">取消</el-button>
            <el-button type="primary" size="mini" @click="ClearStorageB">确定</el-button>
          </div>
          <el-button slot="reference" class="popoverButSub">清除浏览器缓存（B线）</el-button>
        </el-popover>

        <el-popover
          placement="top"
          width="160"
          v-model="visible">
          <p>该操作将清除当前系统在浏览器中的缓存，确定清除吗？</p>
          <div class="popoverBut">
            <el-button size="mini" type="text" @click="visible = false">取消</el-button>
            <el-button type="primary" size="mini" @click="ClearStorage">确定</el-button>
          </div>
          <el-button slot="reference" class="popoverButSub">清除浏览器缓存</el-button>
        </el-popover>

        <el-popover
          placement="top"
          width="160"
          v-model="visibleAll">
          <p>该操作将清除当前系统在浏览器中的（所有）缓存，包括登录状态，确定清除吗？</p>
          <div class="popoverBut">
            <el-button size="mini" type="text" @click="visibleAll = false">取消</el-button>
            <el-button type="primary" size="mini" @click="ClearStorageAll">确定</el-button>
          </div>
          <el-button slot="reference" class="popoverButSub">彻底清除浏览器所有缓存</el-button>
        </el-popover>
    </div>
</template>

<script>
    export default {
        name: "DelCache",
        data() {
          return {
            visible: false,
            visibleA: false,
            visibleB: false,
            visibleAll: false,
          };
        },
        methods: {
            // 清除当前A线在浏览器中的所有缓存
            ClearStorageA(){
                this.visibleA = false;
                localStorage.setItem("OutA", 0);
                localStorage.setItem("doneTimeA", 0);
                this.$message.success("清除成功！！！");
            },

            // 清除当前B线在浏览器中的所有缓存
            ClearStorageB(){
                this.visibleB = false;
                localStorage.setItem("OutB", 0);
                localStorage.setItem("doneTimeB", 0);
                this.$message.success("清除成功！！！");
            },

            // 清除当前系统在浏览器中的缓存
            ClearStorage(){
                this.visible = false;
                localStorage.setItem("OutA", 0);
                localStorage.setItem("OutB", 0);
                localStorage.setItem("doneTimeA", 0);
                localStorage.setItem("doneTimeB", 0);
                localStorage.setItem("initTime", '');
                this.$message.success("清除成功！！！");
            },

            // 清除当前系统在浏览器中的（所有）缓存，包括登录状态
            ClearStorageAll(){
                this.visible = false;
                localStorage.setItem("OutA", 0);
                localStorage.setItem("OutB", 0);
                localStorage.setItem("doneTimeA", 0);
                localStorage.setItem("doneTimeB", 0);
                localStorage.setItem("initTime", '');
                localStorage.setItem("numTimes", '');
                localStorage.setItem("meisuUserName", '');
                localStorage.setItem("meisutoken", '');
                this.$message.success("清除成功！！！");
                this.$router.push({ name: "Login" });
            },
        }
    }
</script>

<style scoped>
    .DelCache{
        width: 100%;
        min-height:100vh;
        background-color: #e0e1e3;
    }
    .popoverBut{
        text-align: right;
        margin: 0;
    }
    .popoverButSub{
        font-size: 0.2rem;
        margin:0.1rem;
        color: #ef5350;
    }

</style>